import { createAction, props } from '@ngrx/store';

import { Account, AuthDetails } from './auth.types';

export const authActions = {
  authenticated: createAction('[Auth] Authenticated', props<{ readonly account: Account }>()),
  logout: createAction('[Auth] Logout', props<{ readonly withRequest: boolean }>()),
  detailsLoaded: createAction('[Auth | GraphQL API] Details Loaded', props<{ readonly details: AuthDetails }>()),
  detailsLoading: createAction('[Auth | GraphQL API] Details Loading'),
  detailsLoadingFailure: createAction('[Auth | GraphQL API] Details Loading Failure', props<{ httpCode?: number }>()),
};
